<template>
  <div>
    <b-table
      :items="items"
      :fields="tableFields"
      sort-by="count"
      class="table-bordered table-hover col-md-12"
      :busy="loading"
    >
      <template v-slot:table-busy>
        <vcl-table
          :speed="5"
          :animate="true"
          :columns="10"
        ></vcl-table>
      </template>
      <template v-slot:cell(actions)="row">
        <div class="d-flex justify-content-center">
          <b-dropdown
            size="sm"
            id="dropdown-left"
            no-caret
            right
          >
            <template slot="button-content">
              <i
                style="font-size: 1rem; padding-right: 0px"
                class="flaticon2-settings"
              ></i>
            </template>
            <b-dropdown-item
              @click="$emit('edit', row.item)"
              v-if="checkPermissions(['INSTALLMENT_UPDATE'])"
            >
              <span style="color: #3f4254; font-size: 12px">
                <i
                  style="font-size: 1rem"
                  class="flaticon2-pen"
                ></i>
                &nbsp; Chỉnh sửa
              </span>
            </b-dropdown-item>
            <b-dropdown-item
              @click="$emit('delete', row.item)"
              v-if="checkPermissions(['INSTALLMENT_DELETE'])"
            >
              <span style="color: #3f4254; font-size: 12px">
                <i
                  style="font-size: 1rem; color: #d33"
                  class="flaticon2-rubbish-bin-delete-button"
                ></i>
                &nbsp; Xóa
              </span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { checkPermissions } from '@/utils/saveDataToLocal';
import { VclTable } from 'vue-content-loading';

export default {
  name: 'InstallmentTable',
  components: {
    VclTable,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableFields: [
        {
          key: 'id',
          label: 'ID',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'name',
          label: 'Tên',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'code',
          label: 'Mã đối tượng',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'phone',
          label: 'Điện thoại',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'createdBy',
          label: 'Người tạo',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: this.checkPermissions([
            'INSTALLMENT_UPDATE',
            'INSTALLMENT_DELETE',
          ])
            ? 'actions'
            : '',
          label: '',
        },
      ],
    };
  },
  methods: {
    checkPermissions,
  },
};
</script> 
